module.exports = __webpack_public_path__ + "c70fc80e46dcecf33ca0e128e8fa7065.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/ca1.png
// module id = 797
// module chunks = 3